interface BrowserCheck {
  isProblematic: boolean;
  browserName: string;
  shouldRedirect: boolean;
}

/**
 * Lightweight detection for browsers that should redirect to default browser
 */
export const checkBrowserCompatibility = (): BrowserCheck => {
  const userAgent = navigator.userAgent.toLowerCase();
  
  // Social media and email in-app browsers (most problematic)
  const problematicBrowsers = [
    { pattern: /linkedin/i, name: 'LinkedIn' },
    { pattern: /fban|fbav/i, name: 'Facebook' },
    { pattern: /instagram/i, name: 'Instagram' },
    { pattern: /twitter/i, name: 'Twitter' },
    { pattern: /tiktok/i, name: 'TikTok' },
    { pattern: /snapchat/i, name: 'Snapchat' },
    { pattern: /whatsapp/i, name: 'WhatsApp' },
    { pattern: /telegram/i, name: 'Telegram' },
    { pattern: /discord/i, name: 'Discord' },
    { pattern: /outlook/i, name: 'Outlook' },
    { pattern: /gmail/i, name: 'Gmail' },
    { pattern: /webview/i, name: 'WebView' },
  ];

  for (const browser of problematicBrowsers) {
    if (browser.pattern.test(userAgent)) {
      return {
        isProblematic: true,
        browserName: browser.name,
        shouldRedirect: true
      };
    }
  }

  return {
    isProblematic: false,
    browserName: 'Compatible Browser',
    shouldRedirect: false
  };
};

/**
 * Attempt to redirect to default browser
 */
export const redirectToDefaultBrowser = (): boolean => {
  const currentUrl = window.location.href;
  const userAgent = navigator.userAgent.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(userAgent);
  const isAndroid = /android/.test(userAgent);

  try {
    if (isIOS) {
      // iOS URL schemes - try Safari first, then Chrome
      window.location.href = `x-web-search://?${encodeURIComponent(currentUrl)}`;
      // Fallback to Chrome if Safari doesn't work
      setTimeout(() => {
        window.location.href = `googlechrome://${currentUrl.replace(/^https?:\/\//, '')}`;
      }, 500);
      return true;
    } else if (isAndroid) {
      // Android intent to open in default browser
      window.location.href = `intent://${currentUrl.replace(/^https?:\/\//, '')}#Intent;scheme=https;action=android.intent.action.VIEW;end`;
      return true;
    } else {
      // Desktop fallback - try opening in new window
      window.open(currentUrl, '_blank');
      return true;
    }
  } catch (error) {
    console.error('Failed to redirect to default browser:', error);
    return false;
  }
};